// ─── Instagram In-App Browser: mega-menu freeze fix ────────────────────────
(function () {
  var ua = navigator.userAgent || '';
  var isInstagramIAB = ua.indexOf('Instagram') !== -1;
  if (!isInstagramIAB) return;

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('summary[data-follow-link]');
      if (!summary) return;

      var href = summary.getAttribute('data-follow-link');
      if (!href) return;

      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });

      window.location.href = href;
    }, true);
  });
})();
// ───────────────────────────────────────────────────────────────────────────

const style = document.createElement('style');
style.textContent = `
  /* The theme styles the SECONDARY image (absolute, hidden, hover-swap) but
     gives the TERTIARY no styles at all — so it sits in normal flow and
     stacks below the primary. Hide it by default, everywhere. */
  .product-card__image--tertiary {
    display: none !important;
  }

  /* On cards the carousel script has claimed, it positions every image
     absolutely itself, so the tertiary is safe to show. .hoe-carousel is
     added by the script below. */
  .hoe-carousel .product-card__image--secondary,
  .hoe-carousel .product-card__image--tertiary {
    mix-blend-mode: normal !important;
    display: block !important;
  }
`;
document.head.appendChild(style);

document.addEventListener('DOMContentLoaded', function() {
  function initProductCardCarousels() {
    if (window.location.pathname.indexOf('/products/') !== -1) return;

    const allContainers = document.querySelectorAll('.shopify-section--featured-collections .product-card__media, .shopify-section--main-collection .product-card__media');

    allContainers.forEach(function(container) {
      const images = container.querySelectorAll('.product-card__image');
      if (images.length < 2) return;

      // Claim this container so the CSS above un-hides the tertiary image
      // and cancels the theme's plus-lighter blend on the secondary.
      container.classList.add('hoe-carousel');

      images.forEach(function(img) {
        img.style.mixBlendMode = 'normal';
      });

      const isMobile = 'ontouchstart' in window;
      const desktopCycle = [1, 2, 0];
      let desktopStep = 0;
      const mobileCycle = [1, 2, 0];
      let mobileStep = 0;
      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let clickTimer = null;

      container.style.position = 'relative';
      container.style.overflow = 'hidden';
      container.style.height = '0';
      container.style.paddingBottom = '100%';

      images.forEach(function(img, i) {
        img.style.position = 'absolute';
        img.style.top = '0';
        img.style.left = '0';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.transition = 'opacity 0.3s ease';
        img.style.opacity = i === 0 ? '1' : '0';
      });

      const dots = document.createElement('div');
      dots.style.cssText = 'position:absolute;bottom:8px;left:0;right:0;display:flex;justify-content:center;gap:4px;z-index:10;pointer-events:none;';
      images.forEach(function(_, i) {
        const dot = document.createElement('span');
        dot.style.cssText = 'width:5px;height:5px;border-radius:50%;background:' + (i === 0 ? '#000' : 'rgba(0,0,0,0.3)') + ';display:inline-block;';
        dots.appendChild(dot);
      });
      container.appendChild(dots);

      function goTo(index) {
        images.forEach(function(img, i) {
          img.style.opacity = i === index ? '1' : '0';
        });
        dots.querySelectorAll('span').forEach(function(dot, i) {
          dot.style.background = i === index ? '#000' : 'rgba(0,0,0,0.3)';
        });
        currentIndex = index;
      }

      if (!isMobile) {
        container.addEventListener('mouseenter', function() {
          goTo(1);
        });
        container.addEventListener('mouseleave', function() {
          goTo(0);
          desktopStep = 0;
        });

        container.addEventListener('click', function(e) {
          e.preventDefault();

          if (clickTimer) {
            // Double click — navigate to product
            clearTimeout(clickTimer);
            clickTimer = null;
            const link = container.closest('a') || container.querySelector('a');
            if (link) window.location.href = link.href;
          } else {
            // Single click — cycle image
            clickTimer = setTimeout(function() {
              clickTimer = null;
              desktopStep = (desktopStep + 1) % desktopCycle.length;
              goTo(desktopCycle[desktopStep]);
            }, 250);
          }
        });
      }

      // Mobile: track touch start position
      container.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      // Mobile: swipe cycles images, tap navigates to product
      container.addEventListener('touchend', function(e) {
        const diffX = startX - e.changedTouches[0].clientX;
        const diffY = startY - e.changedTouches[0].clientY;
        if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
          e.preventDefault();
          const nextIndex = mobileCycle[mobileStep];
          mobileStep = (mobileStep + 1) % mobileCycle.length;
          goTo(nextIndex);
        }
      }, { passive: false });
    });
  }

  initProductCardCarousels();
});